import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFullWidth } from "../../../../../store/stockpile/RecursosVisualeSlice";
import EmptyCircle from "../../../../UI/EmptyCircle";
import TrashIcon from '../../../../../assets/icons/trash.svg'
import EditIcon from '../../../../../assets/icons/edit.svg'
import IconButton from "../../../../UI/buttons/IconButton";
import CopyIcon from "../../../../../assets/icons/copy.svg";
import ProjectDetail from "./tabs/QuoteDetails";
import Quotes from "./tabs/Feedback";
import { RootState } from "../../../../../store/store";
import { useRequest } from 'src/hooks/useRequest';
import { IComment } from 'src/models/CommentModel';
import { useToast } from "../../../../../hooks/useToast";
import { Link, useHistory, useParams } from "react-router-dom";
import FactoryModal from "../../../../Modals/FactoryModal";
import ModalFactoryPreviewQuote from "../../tabs/modalQuotePreview/ModalFactoryPreviewQuote ";
import { AxiosResponse } from "axios";
import { ApiError } from "../../../../../models";
import { UploadError } from "../../../../../util";
import { factoryService } from "../../../../../services/factory";
import ConfirmModal from "../../../../Modals/ConfirmModal";
import { getAllQuotes, getJobsId, getQuotesId, GetQuoteVersion } from "../../../../../store/factory/factoryJobSlice";
import { getAllProject } from "../../../../../store/factory/factorySlice";
import { layoutConfig } from "../../../../../store/layout";
import QuoteNotes from "../../../Quotes/QuoteView/tabs/QuoteNotes";
import QuoteTimeline from "../../../Quotes/QuoteView/tabs/QuoteTimeline";
import QuoteEmailModal from "../../../../Modals/Factory/Quotes/QuoteEmailModal";


interface Props {
  quoteData?:any ;
  setActiveControlView?: any;
  setActiveTask?: any;
  openModal?: boolean;
  setOpenModal?: any;
  setSelectJob?: any;
  selectJob?: any;
  activeTask?: any;
  activeControlView?: any;
  getDataQuotes?: any;
  selectProject?: any;
  idProject?: string;
  setSelectProject?: any;
  closeModalJob: boolean;
  setCloseModalJob: any;
  setAllscreen?:any;
  allscreen?:any
}
const QuoteView: React.FC<Props> = (props) => {
  const FullWidth = ''
  const dispatch = useDispatch()
  const toast = useToast()

  const params = useParams<{ idQuote: any; id: any;  }>();


  const projectDataId: any = useSelector((state: RootState) => state.factorySlice.projectDataId);
  const { jobsData, loading, jobsDataId, QuotesId, QuoteVersion } = useSelector(
    (state: RootState) => state.getJobsTypeSlice
  );

  const { QuoteData } = useSelector(
    (state: RootState) => state.getJobsTypeSlice
  );

  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState<boolean>(false);

  const [currentTab, setCurrentTab] = useState(0);
  const [view, setView] = useState(false);
  const [preview, setPreView] = useState<boolean>(false);
  const [deleteQuoteModal, setDeleteQuoteModal] = useState<boolean>(false);
  const [idQuoteDelete, setIdQuoteDelete] = useState<string>("");
  const [isOpenSendEmailModal, setIsOpenSendEmailModal] = useState<boolean>(false);
  const [quoteAllState, setQuoteAllState] = useState(QuoteData.data);
  const [jodIdDelete, setjobIdDelete] = useState<string | null>(null);


  const { innerHeight } = window

  const [deleteProjectModal, setdeleteProjectModal] = useState<boolean>(false);
  const [deleteJobModal, setDeleteJobModal] = useState<boolean>(false);

  const messageComming = (name: string) => {
    toast.info(name + ' is comming soon!')
  }

  const { data: comments, mutate } = useRequest<IComment[]>({ url: `comments/${QuotesId?._id || params.idQuote}` });

  const tabs = [
    'Details',
    'Feedback',
    'Tasks',
    'Notes',
    'Timeline'
  ];

  const tabsDisbled = [
    'Feedback',
    'Tasks',
   // 'Notes',
  ];

  const tabsContent = [
    <ProjectDetail quotesData={QuotesId} setjobIdDelete={setjobIdDelete} setDeleteJobModal={setDeleteJobModal} />,
    <></>,
    <></>,
    <QuoteNotes
      comments={comments}
      createNote={() => {}}
      deleteNote={() => {}}
      editNote={() => {}}
    />,
    <QuoteTimeline />,
  ];

  const [viewOpenModalFactory, setViewOpenModalFactory] = useState(false);
  const [newActiveControlView, setNewActiveControlView] = useState("");
  const [newActiveTask, setNewActiveTask] = useState("");
  const history = useHistory()
  //const params = useParams<{ id: any; }>();

  const [viewOptions, setViewOptions] = useState(false);

  useEffect(() => {
    dispatch(getQuotesId(params.idQuote));
  }, [params])
  

  const newJob = () => {
    history.replace(`/factory/create/job/${params.id}`);

    props.setActiveControlView("job");
    props.setSelectJob(props.selectProject._id);
  };



  const handleConfirmDelete = () => {
    factoryService
      .DeleteProject(params.id)
      .then((res) => {
        console.log("res from createProject ", res);

        toast.success(
          // res ||
          "The project has been successfully deleted."
        );
        setdeleteProjectModal(false);
        history.push("/factory");
        dispatch(getAllProject());
        // props.setActiveControlView(null);

        return;
      })
      .catch((err: AxiosResponse<ApiError<UploadError[]>>) => {
        console.log("err from delete Project", err);
        if (err?.data?.message) {
          return toast.error(err?.data?.message);
        }
      });
  };
  const getJobsDataId = () => {
   // dispatch(getJobsId(idParamsProject));
  };
  // DELETE JOB

  const handleJobConfirmDelete = () => {
    factoryService
      .DeleteJobs(jodIdDelete)
      .then((res) => {
        console.log("res from createJOB ", res);

        toast.success(
          // res ||
          "The job has been successfully deleted."
        );
        setDeleteJobModal(false);
        getJobsDataId();

        return;
      })
      .catch((err: AxiosResponse<ApiError<UploadError[]>>) => {
        console.log("err from delete job", err);
        if (err?.data?.message) {
          return toast.error(err?.data?.message);
        }
      });
  };

  const getQuotes = () => {
    dispatch(getAllQuotes());
    // dispatch(getQuotesId(idQuotes));
  };

  useEffect(() => {
    if (loading || params.id) {
      getQuotes();
    }
  }, []);

  // DELETE QUOTE

  const handleQuoteConfirmDelete = () => {
    factoryService
      .DeleteQuotes(params.idQuote)
      .then((res) => {
        setIsOpenDeleteModal(false)
        console.log("res from createQUOTE ", res);
        toast.success(
          // res ||
          "The quote has been successfully deleted."
        );
        history.replace('/factory/project/detail/'+ projectDataId)
console.log(projectDataId);

        getQuotes();

        return;
      })
      .catch((err: AxiosResponse<ApiError<UploadError[]>>) => {
        console.log("err from delete quote", err);
        if (err?.data?.message) {
          return toast.error(err?.data?.message);
        }
      });
      setDeleteQuoteModal(false);

  };

  const onCancelModalClose = (value?: boolean) => {
    if (deleteProjectModal) {
      setdeleteProjectModal(false);
    } else if (deleteJobModal) {
      setDeleteJobModal(false);
    } else if (deleteQuoteModal) {
      setDeleteQuoteModal(false);
    }
  };

  const activeModalJob = () => {
    // props.setSelectProject(props.selectProject);
    // history.replace(`/factory/create/job/${id}`);
    setViewOpenModalFactory(true);
  };

  const activeModaltask = () => {
    setViewOpenModalFactory(true);
    setNewActiveControlView("task");
    setNewActiveTask("task");
  };


  const openModalCreate = () => {
    props.setOpenModal(true);
    props.setCloseModalJob(true);
    setViewOptions(true);
  };

  return (
    <>
          {
        isOpenDeleteModal && 
        <ConfirmModal
          title={"Are you sure?"}
          onClose={()=>{}}
          description={
            "This Quote will be discarted"
          }
          buttons={
            <>
              <button
                className="btn btn-danger text-white col-auto"
                onClick={handleQuoteConfirmDelete}
              >
                DELETE
              </button>

              <button
                className="btn btn-success text-white col-auto"
                onClick={() => setIsOpenDeleteModal(false)}
              >
                CANCEL
              </button>
            </>
          }
        />
      }
          <QuoteEmailModal
        isOpen={isOpenSendEmailModal}
        onClose={() => setIsOpenSendEmailModal((prev) => !prev)}
      />
      <ModalFactoryPreviewQuote
        view={view}
        setView={setView}
        toggle={view}
        preview={preview}
        setPreView={setPreView}
        QuoteData={QuoteData}
        QuotesId={QuotesId}
        QuoteVersion={QuoteVersion}
      />

      <FactoryModal
        toggle={setViewOpenModalFactory}
        view={viewOpenModalFactory}
        setView={setViewOpenModalFactory}
        activeControlView={newActiveControlView}
        setActiveControlView={setNewActiveControlView}
        selectJob={props.selectJob}
        setSelectJob={props.setSelectJob}
        activeTask={newActiveTask}
        setActiveTask={setNewActiveTask}
        selectProject={projectDataId}
        setSelectProject={props.setSelectProject}
        closeModalJob={props.closeModalJob}
        setCloseModalJob={props.setCloseModalJob}
        setViewOptions={setViewOptions}
      />

      <header className="w-100 mt-3 d-flex justify-content-between align-items-center ps-1">
        <i
          onClick={() => props.allscreen ? props.setAllscreen(false): props.setAllscreen(true) }
          className={`${FullWidth
            ? 'bi bi-arrows-angle-contract'
            : 'bi bi-arrows-angle-expand'
            } col-auto  h5 m-0`} style={{ fontWeight: 'bold', color: '#344469' }}
        ></i>
        <div className='d-flex' style={{ flexDirection: 'row' }} >


          <div className='d-flex ' style={{ flexDirection: 'column' }}>

            <div className="d-flex align-items-center">
              <Link to={`/factory/edit/project/${''}`}>

                <IconButton
                  color="primary"
                  custom={EditIcon}
                  customStyles={{ width: '12px', height: '12px' }}
                  onClick={() => { }}
                  outline
                />
              </Link>
              <IconButton
                color="primary"
                custom={CopyIcon}
                customStyles={{ width: '12px', height: '12px' }}
                // tooltip="Add"
                onClick={() => { }}
                outline
              />
              <IconButton
                color="primary"
                custom={CopyIcon}
                customStyles={{ width: '12px', height: '12px' }}
                // tooltip="Add"
                onClick={() => { }}
                outline
              />




              <IconButton
                color="danger"
                custom={TrashIcon}
                customStyles={{ width: '12px', height: '12px' }}
                onClick={() => setIsOpenDeleteModal(true)}
                outline
              />
            </div>


          </div>

        </div>

      </header>

      <div className="w-100 mt-3 d-flex justify-content-between ps-1 ms-2 mt-n1">
        <div className="d-flex align-items-center">
        

          <div className="ms-3">
            <p className="m-0 text-black typo-body contact-title text-bold">
              {QuotesId?.name}
            </p>
            <p className="m-0 text-black typo-body contact-subtitle mb-3">
            {QuotesId?.description}
              {
                //ITEM_DATA?.description
              }

            </p>
          </div>
        </div>
      </div>

      <div className="row ms-2 w-100">
        <div className="col-9  d-flex align-items-cente">
          <button className="btn btn-primary mx-1 typo-body col"
            onClick={() => {}}
          >
            View quote
          </button>

          <button className="btn btn-primary mx-1 typo-body col"
            onClick={() => setIsOpenSendEmailModal(true)}
          >
            Send quote
          </button>

          <button className="btn btn-primary mx-1 typo-body col" onClick={activeModaltask} >
            Create task
          </button>

          <button className="btn btn-primary mx-1 typo-body btn-diabled col" onClick={activeModaltask}
          style={{ background: '#F3F3F3' , color: '#8898AA', border: 0 }} >
            Create invoice
          </button>
        </div>
      </div>

      <ul className="nav nav-tabs mt-4 custom-scrollbar" style={{
        overflowX: 'scroll', maxWidth: '60%', flexDirection: 'column',
        maxHeight: '50px', overflowY: 'hidden'
      }} >
        {tabs.map((item, index) => {

          let check = tabsDisbled.find((tab) => {
            if (item == tab) {
              return true;
            }
            return false;
          });
          return (
            <li
              key={index}
              className="nav-item"
              onClick={
                check
                  ? () => messageComming(item)
                  : setCurrentTab.bind(null, index)
              }
              style={check ? { opacity: 0.5 } : {}}
            >
              <p
                className={`nav-link typo-body user-select-none ${currentTab === index ? 'active' : ''
                  }`}
                aria-current="page"
                style={{ fontSize: '10px' }}
              >
                {item}
              </p>
            </li>
          );
        })}
      </ul>

      {deleteProjectModal || deleteJobModal || deleteQuoteModal ? (
        <ConfirmModal
          title="Are you sure?"
          description={
            deleteProjectModal
              ? "This Project will be discarted"
              : deleteJobModal
                ? "This job will be discarted"
                : deleteQuoteModal
                  ? "This Quote will be discarted"
                  : ""
          }
          onClose={onCancelModalClose}
          buttons={
            <>
              <button
                className="btn btn-danger text-white col-auto"
                onClick={
                  deleteProjectModal
                    ? handleConfirmDelete
                    : deleteJobModal
                      ? handleJobConfirmDelete
                      : deleteQuoteModal
                        ? handleQuoteConfirmDelete
                        : undefined
                }
              >
                DELETE
              </button>

              <button
                className="btn btn-success text-white col-auto"
                onClick={() => {
                  onCancelModalClose();
                }}
              >
                CANCEL
              </button>
            </>
          }
        />
      ) : (
        []
      )}

      <div style={{ maxHeight: innerHeight - 320 + 'px' }}>
        {tabsContent[currentTab]}
      </div>
    </>
  )
}

export default QuoteView